module.exports = __webpack_public_path__ + "media/images/index/play-btn-1f71ad271a9c9a9561c8117870d08cba.svg";